import { render, staticRenderFns } from "./DisplayShortcutLinks.vue?vue&type=template&id=776e19a3&scoped=true"
import script from "./DisplayShortcutLinks.vue?vue&type=script&setup=true&lang=js"
export * from "./DisplayShortcutLinks.vue?vue&type=script&setup=true&lang=js"
import style0 from "./DisplayShortcutLinks.vue?vue&type=style&index=0&id=776e19a3&prod&scoped=true&lang=postcss"


/* normalize component */
import normalizer from "!../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "776e19a3",
  null
  
)

export default component.exports